import { useMeasurementUnitsList, useTranslation } from '@msdk/common'
import { EMPTY_CELL_VALUE, Entity, FieldValue } from '@msdk/definitions'
import React from 'react'

interface Props {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  value: FieldValue<any> | null
  row?: Entity
}

export function MeasurementUnit(props: Props) {
  const t = useTranslation()
  const mus = useMeasurementUnitsList()

  let translatedMU = EMPTY_CELL_VALUE

  const mu = mus?.find((x) => x.key === props.value?.value)
  if (mu) {
    translatedMU = t(mu.idml, mu.description)
  } else {
    translatedMU = props.value?.value as string
  }

  return (
    <>
      <span>{translatedMU}</span>
    </>
  )
}
